// An update's frontmatter, read the same way by the app (changelog.ts) and by
// `pnpm check` (scripts/changelog.mjs): its `key: value` lines, quotes
// dropped, and the body after it. Null without one.
export function parseFrontmatter(text) {
  const match = /^---\n([\s\S]*?)\n---\n?([\s\S]*)$/.exec(text.replace(/\r\n/g, "\n"));
  if (!match) return null;
  const data = {};
  for (const line of match[1].split("\n")) {
    const pair = /^([a-z_]+):\s*(.*)$/.exec(line);
    if (pair) data[pair[1]] = pair[2].replace(/^(["'])(.*)\1$/, "$2").trim();
  }
  return { data, body: match[2] };
}
